export const Requests = () => (
  <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.66634 10.6249H6.18911C6.70673 10.6249 7.19498 10.8654 7.51046 11.2758L7.79098 11.6407C8.10645 12.0511 8.5947 12.2916 9.11232 12.2916H10.887C11.4046 12.2916 11.8929 12.0511 12.2084 11.6407L12.4889 11.2758C12.8044 10.8654 13.2926 10.6249 13.8102 10.6249H18.333M18.3579 10.267L15.5893 4.86477C15.3041 4.30828 14.7314 3.95825 14.106 3.95825H5.89331C5.26799 3.95825 4.69529 4.30828 4.41009 4.86477L1.64145 10.267C1.52089 10.5022 1.45801 10.7628 1.45801 11.0271V14.3749C1.45801 15.2954 2.2042 16.0416 3.12467 16.0416H16.8747C17.7951 16.0416 18.5413 15.2954 18.5413 14.3749V11.0271C18.5413 10.7628 18.4785 10.5022 18.3579 10.267Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
)

export default Requests
